export default "__VITE_ASSET__BjxJq8Y8__"